<template>
  <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4">
    <div class="text-sm text-base-content/70">
      Showing {{ (current - 1) * perPage + 1 }}-{{ Math.min(totalItems, current * perPage) }} of {{ totalItems }} items
    </div>
    <div class="join space-x-2">
      <button 
        class="join-item btn btn-primary shadow-none" 
        :class="{ 'btn-disabled': current === 1 }" 
        @click="changePage(current - 1)"
        :disabled="current === 1"
      >
        <d-icon icon="chevron-left" />
      </button>
      
      <template v-for="page in visiblePageNumbers" :key="page">
        <button 
          class="join-item btn shadow-none" 
          :class="{ 
            'bg-secondary-500': page === current,
            'text-primary-content': page === current,
            'bg-white': page !== current,
            'text-base-content': page !== current,
          }"
          @click="changePage(page)"
        >
          {{ page }}
        </button>
      </template>

      <button 
        class="join-item btn btn-primary text-primary-content shadow-none" 
        :class="{ 'btn-disabled': current === lastPage }" 
        @click="changePage(current + 1)"
        :disabled="current === lastPage"
      >
        <d-icon icon="chevron-right"  />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DPagination',
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    },
    current: {
      type: Number,
      default: 1
    },
    maxVisiblePages: {
      type: Number,
      default: 5
    }
  },
  computed: {
    lastPage() {
      return Math.max(1, Math.ceil(this.totalItems / this.perPage));
    },
    visiblePageNumbers() {
      const halfWay = Math.floor(this.maxVisiblePages / 2);
      
      let startPage = this.current - halfWay;
      let endPage = this.current + halfWay;
      
      if (startPage < 1) {
        endPage = Math.min(this.lastPage, endPage + (1 - startPage));
        startPage = 1;
      }
      
      if (endPage > this.lastPage) {
        startPage = Math.max(1, startPage - (endPage - this.lastPage));
        endPage = this.lastPage;
      }
      
      const pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      
      return pages;
    }
  },
  methods: {
    changePage(page) {
      if (page !== this.current) {
        this.$emit('update:current', page);
      }
    }
  }
}
</script>